import './bootstrap';
import Alpine from 'alpinejs';
import imageUploader from './components/image-uploader';
import reviewActions from './components/review-actions';
import moderationActions from './components/moderationActions';
import lightbox from './components/lightbox';
import infiniteScroll from './components/infinite-scroll';

window.Alpine = Alpine;

// Register components
Alpine.data('imageUploader', imageUploader);
Alpine.data('reviewActions', reviewActions);
Alpine.data('moderationActions', moderationActions);
Alpine.data('lightbox', lightbox);
Alpine.data('infiniteScroll', infiniteScroll);

Alpine.start();
